'use client';

import { createContext, ReactNode } from 'react';

import { Dict } from '@/lib/i18n';

// Dictionary of the current language only; the server layout passes it in,
// so other languages never get into the client bundle
export const TranslationsContext = createContext<Dict | undefined>(undefined);

export const TranslationsProvider = ({ dict, children }: { dict: Dict; children: ReactNode }) => {
  return <TranslationsContext.Provider value={dict}>{children}</TranslationsContext.Provider>;
};
